import { useLocation } from "wouter";
import { EmptyState } from "@threadws/jute";

export function NotFoundPage() {
  const [, navigate] = useLocation();
  return (
    <EmptyState
      title="Page not found"
      description="There's nothing at this address."
      actionLabel="Go home"
      onAction={() => navigate("/")}
    />
  );
}
